// Cache para URLs de vídeos para melhorar performance
interface CachedVideo {
  url: string
  expiresAt: number
}

class VideoURLCache {
  private cache = new Map<string, CachedVideo>()
  
  // Armazenar URL no cache com tempo de expiração
  set(path: string, url: string, expiresInSeconds: number = 86400): void {
    const expiresAt = Date.now() + (expiresInSeconds * 1000)
    this.cache.set(path, { url, expiresAt })
  }
  
  // Obter URL do cache se ainda válida
  get(path: string): string | null {
    const cached = this.cache.get(path)
    if (!cached) return null
    
    // Verificar se ainda é válida (com margem de 5 minutos)
    if (Date.now() > (cached.expiresAt - 300000)) {
      this.cache.delete(path)
      return null
    }
    
    return cached.url
  }
  
  // Remover URL do cache
  delete(path: string): void {
    this.cache.delete(path)
  }
  
  // Limpar cache expirado
  cleanup(): void {
    const now = Date.now()
    for (const [path, cached] of this.cache.entries()) {
      if (now > cached.expiresAt) {
        this.cache.delete(path)
      }
    }
  }
  
  // Limpar todo o cache
  clear(): void {
    this.cache.clear()
  }
  
  // Obter estatísticas do cache
  getStats(): { size: number; keys: string[] } {
    return {
      size: this.cache.size,
      keys: Array.from(this.cache.keys())
    }
  }
}

// Singleton do cache
export const videoURLCache = new VideoURLCache()

// Cleanup automático a cada 30 minutos
setInterval(() => {
  videoURLCache.cleanup()
}, 30 * 60 * 1000)
